import React, { useState } from "react";
import { Field } from "formik";
import {toAbsoluteUrl} from "../../../../../_helpers";
import SVG from "react-inlinesvg";
import {OverlayTrigger,Tooltip} from "react-bootstrap";
import { CiCircleMinus, CiCirclePlus } from "react-icons/ci";

export const ShapeLabFancy = ({labFancyData,language}) => {
    const [shape] = useState( labFancyData.length !== 0  && labFancyData[0].lab_shape !== null ? labFancyData[0].lab_shape : [] );
    const newShapeData =shape.length!==0?shape.split(',').map((value,index) => {
        return {
            id: index,
            shape:value,
            multilingualshape:language[`${value.toUpperCase()}`] || value.toUpperCase()
        }
    }):null
    const [shapeImages] = useState( labFancyData.length !== 0 && labFancyData[0].shapeImages !== null ? labFancyData[0].shapeImages : [] );    

    const [shapeLimit, setShapeLimit] = useState(12);
    const showMoreShape = () => setShapeLimit(newShapeData.length);
    const showLessShape = () => setShapeLimit(12);

    return (
        <>
            <div className="row mt-5 pb-8 border-bottom">
                <div className="col-lg-2">
                    <p className="font-size-h6">{language.CCMODE_THEME1_SEARCHDIAMOND_SHAPE}</p>
                </div>
                <div className="col-lg-10">
                    {newShapeData ? newShapeData.slice(0, shapeLimit).map((item) => (
                        <label key={item.id} className="search_btn_check">
                            <Field type="checkbox" name="Shape" id={`${item.shape}_shape`} value={item.shape}/>
                            {/* <span></span> */}
                            <div className="shapeBox selectBox">
                                <SVG src={shapeImages?.svg?.[item.shape] || ""} />
                                <br/>
                                <OverlayTrigger placement="left" overlay={<Tooltip id="tooltip" >{item.multilingualshape}</Tooltip>} >
                                    <span className="text-uppercase text-truncate">{item.multilingualshape}</span>
                                </OverlayTrigger>
                            </div>
                        </label>
                    )):null}
                    {newShapeData && newShapeData.length > 12 &&
                        <span className="search_btn_check" onClick={shapeLimit === newShapeData.length ? showLessShape : showMoreShape}>
                            <div className="shapeBox selectBox">
                                {shapeLimit === newShapeData.length ? <CiCircleMinus /> : <CiCirclePlus />}
                                <br/>
                                <span className="text-uppercase text-truncate">{shapeLimit === newShapeData.length ? "Less" : "More"}</span>
                            </div>
                        </span>
                    }
                </div>
            </div>
        </>
    );
};
